import script from "./ContentErrorView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContentErrorView.vue?vue&type=script&setup=true&lang=ts"

import "./ContentErrorView.vue?vue&type=style&index=0&id=2e852ec9&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e852ec9"]])

export default __exports__